import { Toaster } from "../../ui/toaster";
import { Toaster as Sonner } from "../../ui/sonner";
import { TooltipProvider } from "../../ui/tooltip";
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import { Routes, Route } from "react-router-dom";
import { AppLayout } from "../../components/PromotionIQ/AppLayout";
import { PromotionSelectionProvider } from "../../components/PromotionIQ/PromotionSelectionContext";
import ExecutiveCommand from "./pages/ExecutiveCommand";
import RetailerInvestment from "./pages/RetailerInvestment";
import RetailerEconomics from "./pages/RetailerEconomics";
import RetailerPromotionTruth from "./pages/RetailerPromotionTruth";
import BaselineDiagnostics from "./pages/BaselineDiagnostics";
import PromotionPortfolio from "./pages/PromotionPortfolio";
import PromotionInvestmentBuilder from "./pages/PromotionInvestmentBuilder";
import ShopperInfluenceStack from "./pages/ShopperInfluenceStack";
import ImpactPanel from "./pages/ImpactPanel";
import Scenarios from "./pages/Scenarios";
import Monitoring from "./pages/Monitoring";
import Learnings from "./pages/Learnings";
import Negotiation from "./pages/Negotiation";
import Summary from "./pages/Summary";
import NotFound from "./pages/NotFound";
import "../../assets/css/PromotionIQ/style.css";
import React from "react";
const queryClient = new QueryClient();

const App = () => {
  // Important: shadcn/Radix components render via portals into <body>.
  // If we scope theme tokens only to an inner wrapper, portal content won't inherit them.
  // So while PromotionIQ is mounted, apply a root class + dark mode on <html>.
  React.useEffect(() => {
    const root = document.documentElement;
    root.classList.add("promotioniq-root", "dark");
    return () => {
      root.classList.remove("promotioniq-root", "dark");
    };
  }, []);

  return (
    <QueryClientProvider client={queryClient}>
      <TooltipProvider>
        <Toaster />
        <Sonner />
        <PromotionSelectionProvider>
        <div className="promotioniq-theme dark" style={{ backgroundColor: '#0c1017', minHeight: '100vh' }}>
          <AppLayout>
            <Routes>
              {/*
               * IMPORTANT:
               * This component is mounted at `/promotioniq/*` in the app router.
               * Therefore, child route paths must be RELATIVE (no `/promotioniq` prefix),
               * otherwise routes can fail to match and the main content area appears blank.
               */}
              <Route index element={<ExecutiveCommand />} />
              <Route path="retailer-investment" element={<RetailerInvestment />} />
              <Route path="retailer-economics/:retailerId" element={<RetailerEconomics />} />
              <Route path="retailer-promotion-truth" element={<RetailerPromotionTruth />} />
              <Route path="baseline-diagnostics" element={<BaselineDiagnostics />} />
              <Route path="promotion-portfolio" element={<PromotionPortfolio />} />
              <Route path="promotion-builder" element={<PromotionInvestmentBuilder />} />
              <Route path="shopper-influence" element={<ShopperInfluenceStack />} />
              <Route path="impact-panel" element={<ImpactPanel />} />
              <Route path="scenarios" element={<Scenarios />} />
              <Route path="monitoring" element={<Monitoring />} />
              <Route path="learnings" element={<Learnings />} />
              <Route path="negotiation" element={<Negotiation />} />
              <Route path="summary" element={<Summary />} />
              <Route path="*" element={<NotFound />} />
            </Routes>
          </AppLayout>
        </div>
        </PromotionSelectionProvider>
      </TooltipProvider>
    </QueryClientProvider>
  );
};

export default App;
